import $ from 'jquery'
import store_fiche from "@/store/mods/consultations/fiche-consultations"

export default {
    name: 'manage-fiche-consultation',
    components: {},
    props: {
        selected_consultation: Object,
        info_user: Object,
        modal_toggler: Number,
        mode: {
            type: String,
            default: 'create'
        },
        selected_fiche: {
            type: Object, 
            default: () => ({})
        },
        liste_sections: {
            type: Array,
            default: () => ([])
        },
        fiche_consultations: {
            type: Array,
            default: () => ([])
        },
    },
    data() {
        return {
            section_loading: true,
            filter_section: '',
            fiche_data: {
                libelle: ""
            },

            select_all: '',
            checked_sections: [],
            all_checked: false,
            one_is_checked: [],
            save_loading: false,
            is_error: false,
            err_message: "",
            fiche_id: 0,
            source_fiche_id: 0,

            default_fiche: ''
        }
    },

    watch: {
        modal_toggler() {
            this.fiche_id = this.mode === 'edit' ? this.selected_fiche.id : 0
            this.source_fiche_id = this.mode === 'edit' ? 0 : (this.selected_fiche.id || 0)
            this.fiche_data.libelle = this.mode === 'edit' ? this.selected_fiche.libelle
                : (this.mode === 'duplicate' ? `Copie de ${this.selected_fiche.libelle}` : '')
            this.one_is_checked = this.liste_sections
                .filter(section => Number(section.etat) === 1)
                .map(section => Number(section.section_id))
            this.filter_section = ''
            this.err_message = ""
            this.setDefaultFiche()
        }
    },

    computed: {
        default_consultation_sections(){
            return this.$store.getters["default_consultation_sections"];
        },
        filtered_sections() {
            const query = this.filter_section.trim().toLocaleLowerCase()
            return this.default_consultation_sections.filter(section =>
                !query || (section.libelle || '').toLocaleLowerCase().includes(query)
            )
        },
        modal_title() {
            return this.mode === 'edit' ? 'Modifier la fiche de consultation'
                : (this.mode === 'duplicate' ? 'Dupliquer le modèle' : 'Nouvelle fiche de consultation')
        },
    },

    mounted() {
        this.listeDefaultConsultationSection()
    },

    methods: {
        listeDefaultConsultationSection() {
            this.section_loading = true
            let data = {
                is_default: 0,
                can_show: 1
            }
            this.$store.dispatch('getDefaultConsultationSections', data).then(() => {
                this.section_loading = false
            })
        },

        setDefaultFiche() {
            const default_item = this.fiche_consultations.find(f => f.statut === 1);
            if (default_item) {
                this.default_fiche = default_item.id;
            }

        },

        toutSelectionner() {
            this.one_is_checked = this.one_is_checked.length === this.default_consultation_sections.length
                ? [] : this.default_consultation_sections.map(section => Number(section.id))
        },

        onOneChange() {
            this.all_checked = this.one_is_checked.length === this.default_consultation_sections.length
        },

        async save() {
            this.err_message = ""
            const isValid = await this.$refs.fiche_form.validate();
            if (!isValid) {
                return;
            }
            if (this.one_is_checked.length === 0) {
                this.err_message = 'Choisissez au moins une section.'
                return
            }

            let data = {
                fiche_consultation_id: this.fiche_id,
                source_fiche_id: this.source_fiche_id,
                fiche_consultation: this.fiche_data.libelle,
                sections: this.one_is_checked,
                type_consultation_id: this.selected_consultation.id,
                info_user: this.info_user
            }

            this.save_loading = true
            store_fiche.saveFicheConsultation(data).then((response) => {
                if (response.success && response.code == 200) {
                    this.fiche_data.libelle = ""
                    this.one_is_checked = []
                    $('.add-fiche').modal('hide')
                    this.successToast(response.message)

                    this.$emit('emitFicheConsultation')
                } else {
                    this.err_message = response.message
                }
                this.save_loading = false
            }).catch(() => {
                this.save_loading = false
                this.err_message = "Enregistrement impossible. Vérifiez la connexion et réessayez."
            })
        },

        saveDefaultFiche() {
            const data = {
                type_consultation_id: this.selected_consultation.id,
                default_fiche_id: this.default_fiche
            }
            this.save_loading = true
            
            store_fiche.saveDefaultFicheConsultation(data).then((response) => {
                if (response.success) {
                    this.$refs.c_default.click()
                    this.successToast(response.message)

                    this.$emit('emitFicheConsultation')
                } else {
                    this.err_message = response.message
                }
                this.save_loading = false
            }).catch(() => {
                this.save_loading = false
                this.$refs.c_default.click()
                this.errorToast("Une erreur s'est produite !")
            })
        }
    }
}
